import {Link} from "react-router-dom";
import {
	typeKey,
	typeColor,
	trainingTypeShare,
	trainingTypeValue,
} from "@/utils/trainingTypes";
import "./training-types-matrix.scss";
const number = (value) => (value == null ? "—" : value.toLocaleString("it-IT"));
function Measure({value, total, label, color, partial, scheduled}) {
	const percent = scheduled
		? total > 0
			? 0
			: null
		: trainingTypeShare(value, total);
	return (
		<div
			className={`rtm__measure${partial ? " rtm__measure--partial" : ""}`}
			title={
				scheduled
					? `Allenamento programmato: nessun dato svolto. Totale previsto rosa: ${number(total)} ${label}`
					: `${number(value)}/${number(total)} ${label}${partial ? ": dati parziali o da verificare" : ""}`
			}
		>
			<div>
				<span>
					{number(value)} {label}
					{partial ? " *" : ""}
				</span>
				<small>{percent == null ? "—" : `${percent}%`}</small>
			</div>
			<div className="rtm__track">
				<i
					style={{width: `${Math.min(100, percent || 0)}%`, background: color}}
				/>
			</div>
		</div>
	);
}
export default function TrainingTypesMatrix({
	rows,
	summary,
	metric = "minutes",
	typeColors,
	scope = "completed",
}) {
	if (!summary)
		return <p className="ram__note">Riepilogo tipologie non disponibile.</p>;
	const scheduled = scope === "scheduled";
	const minutes = metric === "minutes";
	const unit = minutes ? "min" : "sedute";
	return (
		<section className="rtm" aria-label="Matrice tipologie allenamenti">
			<p className="ram__note">
				{scheduled
					? "Sedute programmate: dati individuali non ancora disponibili, barre allo 0%. Presenze precompilate escluse fino alla conclusione. "
					: "Solo sedute concluse. "}{" "}
				Barre e percentuali rispetto al totale della rosa nel periodo
				selezionato. Una seduta può contenere più tipologie.
			</p>
			<div
				className="rtm__scroll"
				role="region"
				tabIndex={0}
				aria-label={`${minutes ? "Minuti" : "Sedute"} per giocatore e tipologia`}
			>
				<table className="rtm__table">
					<thead>
						<tr>
							<th className="rtm__player">Giocatore</th>
							{summary.types.map((type) => (
								<th key={typeKey(type)}>
									<span>
										<i style={{background: typeColor(type, typeColors)}} />
										{type.type}
									</span>
									<small>
										Rosa: {number(type[metric])} {unit}
									</small>
								</th>
							))}
							<th className="rtm__total">
								{minutes ? "Minuti totali" : "Sedute totali"}
								<small>
									Rosa: {number(summary[metric])} {unit}
								</small>
							</th>
							<th>{scheduled ? "Stato" : "Da verificare"}</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((player) => {
							const personal = scheduled ? null : player.trainingTypes;
							return (
								<tr key={player.playerId}>
									<th className="rtm__player" scope="row">
										<Link to={`/players/${player.playerId}`}>
											{player.number != null && (
												<small>#{player.number} </small>
											)}
											{player.name}
											{player.guest ? " *" : ""}
										</Link>
									</th>
									{summary.types.map((type) => {
										const own = personal?.types.find(
											(t) => typeKey(t) === typeKey(type),
										);
										const partial = (own?.unknownAttendance || 0) > 0;
										return (
											<td key={typeKey(type)}>
												<Measure
													scheduled={scheduled}
													value={
														personal
															? trainingTypeValue(personal, type, metric)
															: null
													}
													total={type[metric]}
													label={unit}
													color={typeColor(type, typeColors)}
													partial={
														partial ||
														(minutes && own?.missingDuration > 0) ||
														personal?.sessionsWithoutExercises > 0
													}
												/>
											</td>
										);
									})}
									<td className="rtm__total">
										<Measure
											scheduled={scheduled}
											value={personal?.[metric]}
											total={summary[metric]}
											label={unit}
											color={minutes ? "#739bc8" : "#64ad99"}
											partial={
												personal?.unknownAttendance > 0 ||
												(minutes &&
													(personal?.missingDuration > 0 ||
														personal?.sessionsWithoutExercises > 0))
											}
										/>
									</td>
									<td className="rtm__coverage">
										{scheduled ? (
											"Non ancora svolto"
										) : personal ? (
											<>
												{personal.unknownAttendance > 0 && (
													<span>{personal.unknownAttendance} presenze</span>
												)}
												{personal.sessionsWithoutExercises > 0 && (
													<span>
														{personal.sessionsWithoutExercises} senza esercizi
													</span>
												)}
												{personal.missingDuration > 0 && (
													<span>{personal.missingDuration} durate</span>
												)}
												{personal.withoutType > 0 && (
													<span>{personal.withoutType} senza tipo</span>
												)}
												{!personal.unknownAttendance &&
													!personal.sessionsWithoutExercises &&
													!personal.missingDuration &&
													!personal.withoutType &&
													"—"}
											</>
										) : (
											"Non rilevato"
										)}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			{!rows.length && (
				<p className="ram__empty">Nessun giocatore corrisponde alla ricerca.</p>
			)}
			<p className="ram__note">
				{scheduled
					? "Dati individuali non ancora disponibili: lo 0% indica attivita non ancora svolta, non un'assenza."
					: "* Dati parziali o da verificare; — dato non rilevato. Zero indica un'assenza nota, non una presenza mancante. Minuti attribuiti per presenza alla seduta intera, non misurati sul singolo esercizio."}{" "}
				I partecipanti esterni alla rosa attuale hanno * accanto al nome.
			</p>
		</section>
	);
}
